// extracted by mini-css-extract-plugin
export default {"auth-form":"Signup_auth-form__8rLER"};